import React from 'react';
import { AsyncMultiSelectDropdown, BaseInputProps, Option, useFormContextRequired } from 'ui-builder';
import { useProjectRolesService } from 'nekst-api';

export interface ProjectRolesDropdownProps extends BaseInputProps<number[]> {
  notEditableIds?: number[],
  lockedRolesIds?: number[],
  hideTeamMembersOnlyRoles?: boolean,
  hideOwnerRole?: boolean,
}

export function ProjectRolesMultiDropdown(props: ProjectRolesDropdownProps) {
  const projectRolesService = useProjectRolesService();
  const formContext = useFormContextRequired();
  const { lockedRolesIds, ...restProps } = props;

  const loadOptionsFunc = async () => {
    const roles = await projectRolesService.getAllTeamRoles();

    return roles
      .filter((role) => !props.hideTeamMembersOnlyRoles || !['Editor', 'Viewer'].includes(role.name))
      .filter((role) => !props.hideOwnerRole || !role.isOwnerRole)
      .map((role) => {
      return {
        value: role.id,
        label: role.name,
      } as Option;
    });
  };

  const allNotEditableIds = [
    ...(props.notEditableIds || []),
    ...(lockedRolesIds || []),
  ];

  const getLockedProps = () => {
    if (!lockedRolesIds?.length) {
      return {};
    }

    const formRoles: number[] = (formContext.data as any)?.[props.source] || [];

    return {
      value: [...formRoles.filter((id) => !lockedRolesIds.includes(id)), ...lockedRolesIds],
      onChangeCallback: (values: Record<string, any>) => {
        const newRoles = (values[props.source] || []).filter(
          (id: number) => !lockedRolesIds.includes(id),
        );
        formContext.onChangeCallback({ [props.source]: newRoles });
      },
    };
  };

  /* eslint-disable react/jsx-props-no-spreading */
  return (
    <AsyncMultiSelectDropdown
      {...restProps}
      {...getLockedProps()}
      loadOptionsFunc={loadOptionsFunc}
      notEditableIds={allNotEditableIds.length > 0 ? allNotEditableIds : undefined}
    />
  );
}
